import { render, staticRenderFns } from "./SymptomBarChart.vue?vue&type=template&id=641b4776"
import script from "./SymptomBarChart.vue?vue&type=script&lang=js"
export * from "./SymptomBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports